export const LOAD_DATA_DELETION_REQUEST = "LOAD_DATA_DELETION_REQUEST";
export const RESET_GDPR_DATA = "RESET_GDPR_DATA";